import { render, staticRenderFns } from "./ConfigColorLine.page.vue?vue&type=template&id=282a1f9b&"
import script from "./ConfigColorLine.page.vue?vue&type=script&lang=js&"
export * from "./ConfigColorLine.page.vue?vue&type=script&lang=js&"
import style0 from "./ConfigColorLine.page.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports